export const LOAD_CUSTOMERS = 'LOAD_CUSTOMERS';
